import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'

const localTimestamp = (utc, fallback) =>
  utc && moment(utc).isValid()
    ? moment(utc).format('YYYY-MM-DD HH:mm')
    : fallback

/** Inspection registers do not count as scheduled kitchen checks. */
export default function FoodSafetyReportRegisters({ registers, venueId }) {
  if (!registers) return null
  const training = registers.training || []
  const visitors = registers.visitors || []
  const reminders = registers.trainingReminders || []
  return (
    <div data-testid='food-safety-report-registers'>
      <p>
        Completed checks can still have failed readings. Exceptions and
        corrective actions are shown separately.
      </p>
      <details>
        <summary>
          Staff Training · {training.length}{' '}
          {training.length === 1
            ? 'training record / revision'
            : 'training records / revisions'}{' '}
          · {reminders.length} refresher reminders
        </summary>
        {reminders.length ? (
          <p>Refresher status as of {registers.statusDate}:</p>
        ) : null}
        {reminders.map(entry => (
          <p key={`reminder-${entry.recordId}`}>
            <strong>
              {entry.employee} · {entry.status}
            </strong>{' '}
            · Due {entry.refresherDate} · {entry.topics.join(', ')}
          </p>
        ))}
        {training.map(entry => (
          <div key={`${entry.recordId}-${entry.revision}`}>
            <strong>
              {entry.employee} · {entry.trainingDate}
            </strong>
            <p>
              {entry.topics.map(topic => topic.name).join(', ')} · Trainer:{' '}
              {entry.trainer}
            </p>
            <p>
              {entry.loggedLate ? 'Late entry · ' : ''}Recorded{' '}
              {localTimestamp(entry.recordedAtUtc, entry.recordedAt)} by{' '}
              {entry.recordedBy} · Revision {entry.revision}
            </p>
            {entry.changeReason ? (
              <p>Update reason: {entry.changeReason}</p>
            ) : null}
            <p>
              Refresher: {entry.refresherDate || 'Not scheduled'} ·{' '}
              {entry.evidence.length} supporting files
            </p>
          </div>
        ))}
        <Link to={`/v/${venueId}/food-safety/training`}>
          Open Staff Training and full history
        </Link>
      </details>
      <details>
        <summary>
          Contractors &amp; Visitors · {visitors.length} retained visits
        </summary>
        {visitors.map(entry => (
          <div key={entry.recordId}>
            <strong>
              {entry.name}
              {entry.company ? ` · ${entry.company}` : ''}
            </strong>
            <p>
              {entry.purpose} · Arrival:{' '}
              {localTimestamp(entry.arrivedAtUtc, entry.arrival)} · Departure:{' '}
              {localTimestamp(entry.departedAtUtc, entry.departure) ||
                'Not recorded'}
            </p>
            <p>
              Recorded by {entry.recordedBy} · Acknowledged by{' '}
              {entry.acknowledgedBy} at{' '}
              {localTimestamp(entry.acknowledgedAtUtc, entry.acknowledgedAt)}
            </p>
          </div>
        ))}
        <p>
          Visit retention applies. Health declarations are available to
          authorised managers.
        </p>
        <Link to={`/v/${venueId}/food-safety/visitors`}>
          Open Contractors &amp; Visitors
        </Link>
      </details>
    </div>
  )
}
